import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.75C11.0054 6.75 10.0516 7.14509 9.34835 7.84835C8.64509 8.55161 8.25 9.50544 8.25 10.5C8.25 11.4946 8.64509 12.4484 9.34835 13.1517C10.0516 13.8549 11.0054 14.25 12 14.25C12.9946 14.25 13.9484 13.8549 14.6517 13.1517C15.3549 12.4484 15.75 11.4946 15.75 10.5C15.75 9.50544 15.3549 8.55161 14.6517 7.84835C13.9484 7.14509 12.9946 6.75 12 6.75ZM10.409 8.90901C10.831 8.48705 11.4033 8.25 12 8.25C12.5967 8.25 13.169 8.48705 13.591 8.90901C14.0129 9.33097 14.25 9.90326 14.25 10.5C14.25 11.0967 14.0129 11.669 13.591 12.091C13.169 12.5129 12.5967 12.75 12 12.75C11.4033 12.75 10.831 12.5129 10.409 12.091C9.98705 11.669 9.75 11.0967 9.75 10.5C9.75 9.90326 9.98705 9.33097 10.409 8.90901Z"
        fill={colorValue}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6391 22.4075C11.8636 22.5304 12.1371 22.53 12.3616 22.4071C12.3616 22.4071 12.607 22.265 12.7155 22.1982C12.9325 22.0646 13.2388 21.8676 13.6046 21.6091C14.3351 21.0931 15.3098 20.3274 16.2865 19.3273C18.2307 17.3368 20.25 14.3461 20.25 10.5C20.25 8.31196 19.3808 6.21354 17.8336 4.66637C16.2865 3.11919 14.188 2.25 12 2.25C9.81196 2.25 7.71354 3.11919 6.16637 4.66637C4.61919 6.21354 3.75 8.31196 3.75 10.5C3.75 14.3461 5.76933 17.3368 7.71345 19.3273C8.69025 20.3274 9.66491 21.0931 10.3954 21.6091C10.7612 21.8676 11.0675 22.0646 11.2845 22.1982C11.393 22.265 11.6391 22.4075 11.6391 22.4075ZM7.22703 5.72703C8.4929 4.46116 10.2098 3.75 12 3.75C13.7902 3.75 15.5071 4.46116 16.773 5.72703C18.0388 6.9929 18.75 8.70979 18.75 10.5C18.75 13.7959 17.0193 16.4302 15.2135 18.2792C14.3152 19.1989 13.4149 19.9066 12.7391 20.384C12.4411 20.5945 12.1881 20.7593 12 20.8769C11.8119 20.7593 11.5589 20.5945 11.2609 20.384C10.5851 19.9066 9.68475 19.1989 8.78655 18.2792C6.98067 16.4302 5.25 13.7959 5.25 10.5C5.25 8.70979 5.96116 6.9929 7.22703 5.72703Z"
        fill={colorValue}
      />
    </svg>
  );
};
